import React from "react";

import { baseURL } from "../../../services/api.service";
import styles from "./installationClaimPDF.module.css";

const InstallationClaimPDF = ({ data, groupedItems }) => {
  let serialNumber = 1;
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  const totalInstallationQty =
    data?.installation_items &&
    data?.installation_items?.reduce(
      (acc, item) => acc + (parseFloat(item?.already_installed_qty) || 0),
      0
    );

  const FloatValue = (value) => {
    return parseFloat(value);
  };
  const formatNumberWithBreaks = (num) => {
    if (!num && num !== 0) return "-";
    return parseFloat(num).toLocaleString("en-IN", {}).replace(/,/g, ",\u200B");
  };
  return (
    <div className={styles.mainContainer}>
      <div className={styles.header}>
        <div className={styles.logoSection}>
          <img
            src="https://bermadimsapi.disctesting.in/uploads/logo/8e08ec4e6348fc2fe1f64ae147db7496.jpeg"
            alt="BERMAD"
            className={styles.logo}
          />
          <div className={styles.companyName}>
            BERMAD INDIA Private Limited.
          </div>
        </div>
        <div className={styles.addressRight}>
          <h2 className={styles.orderTitle}>Installation Claim Details</h2>
          <div>
            <strong>Project Name:</strong> {data?.project_name || "-"}
          </div>
          <div>
            <br />
            <strong>Project Code:</strong> {data?.project_code || "-"}
          </div>
        </div>
      </div>

      <div className={styles.blueBar}></div>

      <table className={styles.orderHeader}>
        <tbody>
          <tr>
            {/* <th>Installation Person Name:</th> */}
            <th style={{ width: "33%", textAlign: "left" }}>Installation No</th>
            <th style={{ width: "33%", textAlign: "left" }}>Form Name</th>
            <th style={{ width: "33%", textAlign: "left" }}>Field Name</th>
            <th style={{ width: "33%", textAlign: "left" }}>Status</th>

            <th style={{ width: "33%", textAlign: "left" }}>Date</th>
          </tr>
          <tr>
            {/* <td>vinayak sir</td> */}
            <td className={styles.cellWrap} style={{ textAlign: "left" }}>
              {data?.installation_no}
            </td>
            <td className={styles.cellWrap} style={{ textAlign: "left" }}>
              {data.form_name || "-"}
            </td>
            <td className={styles.cellWrap} style={{ textAlign: "left" }}>
              {data?.field_name || "-"}{" "}
            </td>
            <td className={styles.cellWrap} style={{ textAlign: "left" }}>
              {" "}
              {data?.installation_status?.split("_").join(" ").toUpperCase()}
            </td>
            <td className={styles.cellWrap} style={{ textAlign: "left" }}>
              {formatDate(data.createdAt) || "-"}
            </td>
          </tr>
        </tbody>
      </table>

      <table className={styles.catalogTable}>
        <thead>
          <tr>
            <th>Sr No</th>
            <th>Item Code</th>
            <th>UOM</th>
            <th>Required Qty</th>
            <th>Assigned Qty</th>
            <th>Installed Qty</th>
          </tr>
        </thead>
        <tbody>
          {Object.values(groupedItems).map((group, index) => (
            <React.Fragment key={group.makeItem.unique_id}>
              {group.makeItem.is_make_item && (
                <tr>
                  <td className={styles.textCenter}>{serialNumber++}</td>
                  <td>
                    <div className={styles.itemDescription}>
                      <div className={styles.itemCode}>
                        {group.makeItem.item_code || "N/A"}
                      </div>
                      <div className={styles.itemDesc}>
                        <span>Product Description:</span>
                        <br />
                        {group?.makeItem?.make_item_desc || "N/A"}
                      </div>
                    </div>
                  </td>
                  <td className={styles.textCenter}>
                    {group?.makeItem?.make_item_uom}
                  </td>

                  <td className={styles.textRight}>{"-"}</td>
                  <td className={styles.textRight}>{"-"}</td>
                  <td className={styles.textRight}>{"-"}</td>
                </tr>
              )}

              {group.buyItems
                .filter((item) => item.is_make_item)
                .map((row, subIndex) => (
                  <tr key={row.unique_id} className={styles.subItemRow}>
                    <td
                      className={`${styles.textCenter} ${styles.subItemIndex}`}
                    >
                      {`${serialNumber - 1}.${subIndex + 1}`}
                    </td>
                    <td>
                      <div className={styles.subItemCode}>
                        {row?.buy_item_code || "N/A"}
                        <div className={styles.subItemDesc}>
                          <span>Product Description:</span>
                          <br />
                          {row?.description || "N/A"}
                        </div>
                      </div>
                    </td>
                    <td className={styles.textCenter}>{row?.uom || "N/A"}</td>
                    <td className={styles.textRight}>
                      <div className={styles.numberWrapper}>
                        {formatNumberWithBreaks(row?.required_qty) || 0}
                      </div>
                    </td>
                    <td className={styles.textRight}>
                      <div className={styles.numberWrapper}>
                        {formatNumberWithBreaks(row?.assigned_qty) || "0"}
                      </div>
                    </td>

                    <td className={styles.textRight}>
                      <div className={styles.numberWrapper}>
                        {formatNumberWithBreaks(row?.already_installed_qty) ||
                          0}
                      </div>
                    </td>
                  </tr>
                ))}
              {group.buyItems
                .filter((item) => item.is_make_item == false)
                .map((row, subIndex) => (
                  <tr key={row.unique_id}>
                    <td className={styles.textCenter}>{serialNumber++}</td>

                    <td>
                      <div className={styles.itemDescription}>
                        <div className={styles.itemCode}>
                          {row?.item_code || "N/A"}
                        </div>
                        <div className={styles.itemDesc}>
                          <span>Product Description:</span>
                          <br />
                          <span> {row?.description || "N/A"}</span>
                        </div>
                      </div>
                    </td>
                    <td className={styles.textCenter}> {row?.uom || "-"}</td>
                    <td className={styles.textRight}>
                      {isNaN(row?.required_qty)
                        ? 0
                        : formatNumberWithBreaks(row?.required_qty) || "0"}
                    </td>
                    <td className={styles.textRight}>
                      <div className={styles.numberWrapper}>
                        {isNaN(row?.assigned_qty)
                          ? 0
                          : formatNumberWithBreaks(row?.assigned_qty) || "0"}
                      </div>
                    </td>

                    <td className={styles.textRight}>
                      <div className={styles.numberWrapper}>
                        {" "}
                        {isNaN(row?.already_installed_qty)
                          ? 0
                          : formatNumberWithBreaks(
                              row?.already_installed_qty
                            ) || "0"}
                      </div>
                    </td>
                  </tr>
                ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      <div className={styles.totalsSectionRight}>
        <table className={styles.totalsTable}>
          <tbody>
            <tr className={styles.grandTotal}>
              <td className={styles.totalLabel}>TOTAL INSTALLATION QTY:</td>
              <td className={styles.totalValue}>
                <div className={styles.scientificNumber}>
                  {formatNumberWithBreaks(totalInstallationQty) || "0"}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {data?.installations?.file?.length > 0 && (
        <div className="p-3">
          <h6 className="h-6-pdfheading">Images:</h6>
          <div
            className="row mt-2"
            style={{ display: "flex", flexWrap: "wrap" }}
          >
            {data &&
              data?.installations?.file?.length > 0 &&
              data.installations.file.map((item, index) => (
                <img
                  src={baseURL + item.filePath}
                  alt="Installation Image"
                  style={{
                    width: "300px",
                    height: "300px",
                    borderRadius: "5px",
                    marginBottom: "10px",
                  }}
                />
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default InstallationClaimPDF;
